/** Group injury rows by team name for display. */
export function groupInjuriesByTeam(injuries = []) {
  const byTeam = new Map();
  for (const row of injuries) {
    const team = row.team || 'Unknown';
    if (!byTeam.has(team)) byTeam.set(team, []);
    byTeam.get(team).push(row);
  }
  return [...byTeam.entries()]
    .sort(([a], [b]) => a.localeCompare(b))
    .map(([team, players]) => ({
      team,
      players: players.sort((x, y) => String(x.player).localeCompare(String(y.player))),
    }));
}

const POS_META = {
  F: { label: 'FWD', tone: 'fwd' },
  FW: { label: 'FWD', tone: 'fwd' },
  FWD: { label: 'FWD', tone: 'fwd' },
  FORWARD: { label: 'FWD', tone: 'fwd' },
  D: { label: 'DEF', tone: 'def' },
  DEF: { label: 'DEF', tone: 'def' },
  DEFENDER: { label: 'DEF', tone: 'def' },
  M: { label: 'MID', tone: 'mid' },
  MID: { label: 'MID', tone: 'mid' },
  MF: { label: 'MID', tone: 'mid' },
  MIDFIELDER: { label: 'MID', tone: 'mid' },
  G: { label: 'GK', tone: 'gk' },
  GK: { label: 'GK', tone: 'gk' },
  GOALKEEPER: { label: 'GK', tone: 'gk' },
};

export function positionMeta(position) {
  const key = String(position || '')
    .trim()
    .toUpperCase();
  return POS_META[key] || { label: key || '—', tone: 'other' };
}

export function playerInitials(name) {
  const parts = String(name || '')
    .trim()
    .split(/\s+/)
    .filter(Boolean);
  if (!parts.length) return '?';
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return `${parts[0][0]}${parts[parts.length - 1][0]}`.toUpperCase();
}

export function countByPosition(players = []) {
  const counts = { fwd: 0, def: 0, mid: 0, gk: 0, other: 0 };
  for (const p of players) {
    const tone = positionMeta(p.position).tone;
    counts[tone] = (counts[tone] || 0) + 1;
  }
  return counts;
}
